subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event.source === 'temp-hold-observer') {
    return;
  }

  // console.log(event.cartData);

  const tempHoldProductId = JSON.parse(document.querySelector('meta[name=temp-hold-product]').getAttribute('content'));
  const tempHoldVariants = JSON.parse(document.querySelector('meta[name=temp-hold-variants]').getAttribute('content'));
  const variantMap = tempHoldVariants.reduce((acc, curr) => {acc[parseInt(curr.title)] = curr.id; return acc}, {})

  const findNearest = (needle, haystack) => {
    const roundedNeedle = Math.round(needle);
    return haystack.reduce((prev, curr) => Math.abs(curr - needle) < Math.abs(prev - needle) ? curr : prev);
  };

  const findVariant = (estimate, variantMap) => {
    const rounded = findNearest(estimate, Object.keys(variantMap));
    found_variant = variantMap[rounded];
    return found_variant;
  };

  const ensureCartData = (event) => {
    if (event.cartData && 'items' in event.cartData) {
      // console.log('cart data and items present');
      return Promise.resolve(event.cartData);
    } else {
      // console.log('fetching cart data');
      return fetch(`${routes.cart_url}.js`).then((response) => response.json());
    }
  }

  ensureCartData(event).then((cartData) => {
    const existingTempHoldItems = cartData.items.filter(line => line.product_id === tempHoldProductId);
    const subtotal = cartData.items_subtotal_price - existingTempHoldItems.reduce((sum, item) => sum + item.final_line_price, 0);
    const tempHoldFactor = 0.2;
    const estimated_hold = (subtotal / 100.0) * tempHoldFactor;

    const foundVariant = findVariant(estimated_hold, variantMap);
    // console.log(cartData.items);
    const onlyTempHoldItemsLeft = cartData.items.length === existingTempHoldItems.length;
    const changeItems = existingTempHoldItems.reduce((acc, curr) => {acc[curr.id] = 0; return acc}, {});

    if (!onlyTempHoldItemsLeft) {
      changeItems[foundVariant] = 1;
    }

    // console.log(foundVariant);
    // console.log(changeItems);
    // console.log(event);

    if(Object.keys(changeItems).length > 0) {
      const body = JSON.stringify({ updates: changeItems });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'temp-hold-observer', cartData: parsedState, variantId: foundVariant });
        })
    }
  });
});
